import { InfoCircleOutlined } from '@ant-design/icons';
import { Form, Input, Tabs, Typography } from 'antd';

import { PublicationSelectionMode } from '@app/components/Modals/BotDetailsModal/types';

import {
  PUBLICATION_MODE_TAB_KEYS,
  useInstagramPublicationsField,
} from '../hooks/useInstagramPublicationsField';

import { InstagramPublicationsGrid } from './InstagramPublicationsGrid';

import type { FC } from 'react';

import './InstagramPublicationsField.scss';

const { Text } = Typography;

interface InstagramPublicationsFieldProps {
  socialIntegrationType: string | undefined;
}

export const InstagramPublicationsField: FC<
  InstagramPublicationsFieldProps
> = ({ socialIntegrationType }) => {
  const {
    integrationId,
    isIntegrationMissing,
    isSelectedMode,
    activeTabKey,
    modeTabChangeHandler,
    publicationIdsRules,
  } = useInstagramPublicationsField({ socialIntegrationType });

  if (isIntegrationMissing) {
    return (
      <Text
        type="secondary"
        className="InstagramPublicationsField InstagramPublicationsField--no-integration"
        data-testid="instagram-publications-no-integration"
      >
        <InfoCircleOutlined aria-hidden /> Чтобы выбрать публикации, выберите
        интеграцию Instagram в поле «Интеграция».
      </Text>
    );
  }

  // Блок есть только у конкретной интеграции Instagram
  if (integrationId === null) {
    return null;
  }

  return (
    <div className="InstagramPublicationsField">
      <Text strong>Публикации</Text>

      {/* Режим хранится в форме: вкладки меняют его через хук */}
      <Form.Item name="publicationSelectionMode" hidden noStyle>
        <Input type="hidden" />
      </Form.Item>

      <Tabs
        size="small"
        activeKey={activeTabKey}
        onChange={modeTabChangeHandler}
        items={[
          {
            key: PUBLICATION_MODE_TAB_KEYS[PublicationSelectionMode.All],
            label: 'Все публикации',
            children: (
              <Text type="secondary">
                Робот отвечает на сообщения в Direct и на комментарии под всеми
                публикациями аккаунта.
              </Text>
            ),
          },
          {
            key: PUBLICATION_MODE_TAB_KEYS[PublicationSelectionMode.Selected],
            label: 'Выбранные',
            children: (
              <div className="InstagramPublicationsField__selected">
                <Text type="secondary">
                  Робот отвечает только на комментарии под выбранными
                  публикациями. Сообщения в Direct робот пропускает.
                </Text>

                <Form.Item
                  name="instagramPublicationIds"
                  dependencies={['publicationSelectionMode']}
                  rules={publicationIdsRules}
                  className="InstagramPublicationsField__ids"
                >
                  <InstagramPublicationsGrid
                    integrationId={integrationId}
                    isEnabled={isSelectedMode}
                  />
                </Form.Item>
              </div>
            ),
          },
        ]}
      />
    </div>
  );
};
